import React from "react";
import { SensorOccupied } from "@mui/icons-material";

export const getPresentIcon = (widget = null) => {
  const iconProps = {
    style: {
      fontSize: "1.5rem",
      paddingBottom: "2px",
    },
  };
  return <SensorOccupied {...iconProps} />;
};

export const getPresentSubtitle = (widget = null) => {
  if (!widget) return "";
  const isPresent = widget?.items?.$w1?.value === "present";
  return isPresent ? "Present" : "Clear";
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getPresentPatterns = () => {
  return ["basic.device.presence"];
};
